(function(){
  // collection列表页过滤器size分类排序处理
  async function collectionFilterHandle(){
    // collectionFilterColor()
    collectionFilterColor2()
    // collectionFilterOthers("#shopify-section-facets #blockid_3 ul", ['Thermal', 'Naked', 'Natural'])
    // collectionFilterOthers("#shopify-section-facets #blockid_4 ul")
  }
  async function collectionFilterColor2(){
    const element="#shopify-section-facets #blockid_5 ul li"
    await MB_waitElementReady(element)
    $(element).each(function(){
      const class_name = $(this).find('[class*=bg_color_]').attr('class')
      const match = /bg_color_(.*?) /ig.exec(class_name)
      if(match){
        const color = match[1]
        const url = `//cdn.shopify.com/s/files/1/0506/5284/0124/t/37/assets/${color}_50x.png`
        $(this).find('[class*=bg_color_]').css("backgroundImage","url('"+url+"')")

      }
    })

  }
  async function collectionFilterColor(){
    const element="#shopify-section-facets #blockid_6 ul"
    await MB_waitElementReady(element)
    const sizeFirstArr = ['xs','s','s/m','m','l','xl','xxl','2xl','3xl','4xl']
    const sizeArr1 = $(`${element} li`).filter((i,o)=>{
      const size = /(.*)\(/.exec($(o).text())[1].toLowerCase()
      return sizeFirstArr.indexOf(size) >- 1
    })
    const sizeArr2 = $(`${element} li`).filter((i,o)=>{
      const size = /(.*)\(/.exec($(o).text())[1].toLowerCase()
      return sizeFirstArr.indexOf(size) == -1
    })
    const sizeArr1Last = sizeArr1.last()
    // console.log(sizeArr1)
    // const arr = $.merge(sizeArr1, sizeArr2)
    // $(element).html(arr)
    // sizeArr1Last.after(`<div style='width:100%;height:20px;'></div>`)
    $(element).html(sizeArr1)
  }
  async function collectionFilterOthers(element, nameArr=null){
    // const element="#shopify-section-facets #blockid_3 ul"
    await MB_waitElementReady(element)
    // 先排序
    sortedList = $(`${element} li`).sort(function(a, b){
      const countA = Number(/\((\d+)\)/.exec($(a).find('.t4s-value-count').text())[1])
      const countB = Number(/\((\d+)\)/.exec($(b).find('.t4s-value-count').text())[1])
      // console.log(countA, countB)
      return countB - countA
   });
   $(element).html(sortedList)

    //  再把有用的筛选出来，这步不是必须的
   if(nameArr!=null && nameArr.length > 0){
     // const nameArr = ['Thermal', 'Naked', 'Natural']
     const arr1 = $(`${element} li`).filter((i,o)=>{
       const name = /(.*)\(/.exec($(o).text())[1].toLowerCase()
       let isInArr = false
       for(let n of nameArr){
         if(name.indexOf(n.toLowerCase()) >- 1){
           isInArr = true
           break
          }
        }
        return isInArr
      })
      
      $(element).html(arr1)
    }

  }
  // 产品列表页两图轮换
  let isSwitch2ImagesStart = false
  async function switch2Images(){
    await MB_waitElementReady(".t4s-product-img img[data-pr-img2]")
    await MB_sleep(5000)
    !isSwitch2ImagesStart && switch2ImagesLoop()
    isSwitch2ImagesStart = true
  }
  async function switch2ImagesLoop(isShowImage2=true){
    $(".t4s-product-img img[data-pr-img2]").animate({opacity: isShowImage2 ? 1: 0})
    isShowImage2 = !isShowImage2
    await MB_sleep(5000)
    switch2ImagesLoop(isShowImage2)
  }
  async function collectionInfoViewMore(){
    const el = ".template-collection .mibao_bottom_seo_info"
    await MB_waitElementReady(el)
    
    $(el).find(".button_more_less").click(function(){
      const parent = $(this).parent()
      const lines = parent.css("--show-lines")
      console.log(lines)
      if(lines<=5){
        parent.css("--show-lines", "99999")
        $(this).text("Read Less>")
      }else{
        parent.css("--show-lines", "5")
        $(this).text("Read All>")
      }
    })

  }
  async function collection61Banner(){
    if($(".mibao-collection-61banner").length && $(".mibao-collection-61banner .mibao-banner-item").length){
      $(".t4s-products .t4s-product[isDoneBanner!=1]").each(function(i){
        const count = i+1
        if(count % 16 == 0){
          $(this).after($($(".mibao-collection-61banner .mibao-banner-item[device=pc]")[0]))
        }
        if(count % 12 == 0){
          $(this).after($($(".mibao-collection-61banner .mibao-banner-item[device=mobile]")[0]))
        }
        $(this).attr("isDoneBanner",1)
      })
    }
  }
  async function selectCurrentColorImage(){
    await MB_sleep(2000)
    const el = '.t4s-products .t4s-product:not(.is_check_color) .t4s-pr-color__name'
    await MB_waitElementReady(el, preTime=100, total=30)
    await MB_sleep(1000)
    // console.log($(el).length)
    const colors = MB_getUrlParam('filter.v.option.color')
    if(colors){
      const target_color = typeof(colors)=='string' ? colors.toLowerCase() : colors[0].toLowerCase() 
      $('.t4s-products .t4s-product:not(.is_check_color)').each(function(){
        let is_clicked = false
        $(this).find('.t4s-pr-color__name').each(function(){
          const color = $(this).text().toLowerCase()
          if(!is_clicked && color.indexOf(target_color)>-1){
            console.log($(this), color, target_color)
            $(this).parent().mouseover()
            is_clicked = true
          }
          $(this).addClass('is_check_color')
        })
      })
    }
  }

  let current_url = location.href
  function checkUrlChange(){
    if(current_url!=location.href){
      selectCurrentColorImage()
      current_url = location.href
      console.log('url change')
    }
    setTimeout(()=>{checkUrlChange()}, 1000)
  }
  function onScroll(){
    MB_jsDeferHandle(collection61Banner, ['jQuery'])
    // MB_jsDeferHandle(selectCurrentColorImage, ['jQuery'])
  }



  function init(){
    MB_jsDeferHandle(collectionFilterHandle, ['jQuery'])
    MB_jsDeferHandle(collectionInfoViewMore, ['jQuery'])
    // MB_jsDeferHandle(selectCurrentColorImage, ['jQuery'])
    // MB_jsDeferHandle(switch2Images, ['jQuery'])
    window.addEventListener( "scroll", () => { onScroll() }, false )

    // checkUrlChange()
  }
  
  MB_jsDeferHandle(init, ['jQuery'])
}) ()
